export default function onHandleTap({ target }) {
  const targetEl = $(target);

  const removeClasses = [
    'answer--max-diff-disabled',
    'answer--max-diff-choice-clicked',
  ].join(' ');

  // remove all the highlights from the clicked element
  targetEl.removeClass(removeClasses);
  // remove all the highlights from the clicked element siblings
  targetEl.siblings().removeClass(removeClasses);
  // highlights all siblings as disabled
  targetEl.siblings().addClass('answer--max-diff-disabled');

  // when the click is on the best option
  if (targetEl.hasClass('answer--max-diff-best')) {
    // highlight the selected value for this answer
    targetEl.addClass('answer--max-diff-choice-clicked');
    // remove from the closest answer element the data-answer if was selected previously
    targetEl.closest('.answer--max-diff').removeAttr('data-answer-worst');
    // remove from all answers elements the data-answer if was selected previously as best
    $('.answer--max-diff').removeAttr('data-answer-best');
    // add to the closest answer element the data-answer to be best
    targetEl.closest('.answer--max-diff').attr('data-answer-best', 'true');
    // remove highlights from all best option of answers except the clicked element
    $('.answer--max-diff-best')
      .not(targetEl)
      .removeClass(removeClasses);
    // highlight all best option of answers as disabled except the clicked element
    $('.answer--max-diff-best')
      .not(targetEl)
      .addClass('answer--max-diff-disabled');

    // if there is a previously selected worst option
    if (
      $('.answer--max-diff-worst.answer--max-diff-choice-clicked').length === 0
    ) {
      // remove highlights from each non sibling element
      $('.answer--max-diff-worst')
        .not(targetEl.siblings())
        .removeClass(removeClasses);
    }
  }

  // when the click is on the worst option
  if (targetEl.hasClass('answer--max-diff-worst')) {
    // highlight the selected value for this answer
    targetEl.addClass('answer--max-diff-choice-clicked');
    // remove from the closest answer element the data-answer if was selected previously
    targetEl.closest('.answer--max-diff').removeAttr('data-answer-best');
    // remove from all answers elements the data-answer if was selected previously as worst
    $('.answer--max-diff').removeAttr('data-answer-worst');
    // add to the closest answer element the data-answer to be worst
    targetEl.closest('.answer--max-diff').attr('data-answer-worst', 'true');
    // remove highlights from all worst option of answers except the clicked element
    $('.answer--max-diff-worst')
      .not(targetEl)
      .removeClass(removeClasses);
    // highlight all worst option of answers as disabled except the clicked element
    $('.answer--max-diff-worst')
      .not(targetEl)
      .addClass('answer--max-diff-disabled');
    // if there is a previously selected best option
    if (
      $('.answer--max-diff-best.answer--max-diff-choice-clicked').length === 0
    ) {
      // remove highlights from each non sibling element
      $('.answer--max-diff-best')
        .not(targetEl.siblings())
        .removeClass(removeClasses);
    }
  }
  // add to the answer element the answer selection class
  // remove comment if we no longer add the answerClick class by default
  // targetEl.closest('.answer--max-diff').addClass('answerClick');
}
